import React from "react";
import { Button, dialog } from "../../../nq-component";
import {
  addSchemaUseCase,
  updateSchemaUseCase,
  deleteSchemaUseCase,
} from "../../../usecases/schema/usecases";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { exportCSVUseCase } from "../../../usecases/csv/usecases";
import { Progress, InfiniteScroll } from "../../../nq-component";
import withRouter from "../../../withRouter";
import Search from "../../../components/Search";
import BaseListPage from "../../../base/BaseListPage";
import NavBar from "../../../components/navbar";
import InputFactory from "../../../components/InputFactory";
import LastPayListPresenter from "./LastPayListPresenter";
import Table from "../../../components/Table";
import EmployeeDetails from "./components/EmployeeDetails";
import excludeFields from "./components/ExcludeField";
import DialogDone from "./components/DialogDone";
import DialogContinue from "./components/DialogContinue";
import DialogSuccess from "./components/DialogSuccess";
import { object } from "framer-motion/m";
import DialogConfirmation from "./components/DialogConfirmation";
import { footer } from "framer-motion/client";
import DialogUploadQC from "./components/DialogUploadQC";
import { get } from "nq-js/dist/Config";

class LastPayListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new LastPayListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      exportCSVUseCase(),
      addSchemaUseCase(),
      updateSchemaUseCase(),
      deleteSchemaUseCase(),
      getObjectUseCase()
    );
    this.state = {
      objects: [],
      selected: [],
      loading: false,
      quitClaim: "",
      total: 0,
      count: 0,
      where: {},
      showDetails: false,
      empDetails: {},
      showFilters: false,
      formData: {
        requestType: "",
        remarks: "",
        attachment: "",
      },
    };
  }

  getCollectionName() {
    return "employees";
  }

  onClickAdd() {
    this.presenter.onClickAdd();
  }

  clickData(object, index) {
    console.log(object);
    this.setState({
      showFilters: true,
      showDetails: true,
      empDetails: object,
    });
  }

  hideFilter() {
    this.setState({ showFilters: false });
  }

  onClickEdit() {
    const { empDetails } = this.state;
    this.presenter.onClickEdit(empDetails);
  }

  onClickUpdateStatus() {
    const { empDetails } = this.state;
    this.presenter.onClickUpdateStatus(empDetails);
  }

  onClickView() {
    const { empDetails } = this.state;
    const view = "viewing";
    this.navigateTo(`/admin/employees/form/${view}/${empDetails?.id}`);
  }

  onChangeObject(value, field) {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [field]: value,
      },
    }));
  }

  showFilter() {
    this.setState({ showFilters: true });
  }

  successModal() {
    dialog.fire({
      html: (
        <>
          <DialogSuccess />
        </>
      ),
      footer: false,
    });
  }

  onSubmit() {
    const { empDetails, quitClaim } = this.state;
    dialog.close();
    this.presenter.handleSubmit(empDetails, quitClaim);
  }

  handleFileChange(value) {
    this.setState({ quitClaim: value });
  }

  dialogUploadQC() {
    dialog.fire({
      html: (
        <DialogUploadQC
          handleFileChange={this.handleFileChange.bind(this)}
          handleSubmit={this.onSubmit.bind(this)}
        />
      ),
      footer: false,
    });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const {
      objects,
      selected,
      count,
      progress,
      empDetails,
      showFilters,
      showDetails,
    } = this.state;
    if (!schema) return <Progress />;
    const user = this.getCurrentUser();
    console.log(objects);
    return (
      <>
        <NavBar user={user} />
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div className="d-flex justify-content-between align-items-center">
                <h1 className="fw-bold text-capitalize">Last Pay</h1>
                <div className="text-nowrap">
                  <span className="ms-2">
                    {selected.length > 0 ? "Selected: " : "Total: "}
                  </span>
                  <span className="fs-sm text-nowrap">
                    {selected.length > 0 ? selected.length : objects.length}
                  </span>
                  <span className="ms-1">of </span>
                  <span className="fs-sm text-nowrap">{count}</span>
                </div>
              </div>
              <div className="d-flex justify-content-start">
                <p
                  className="align-self-end m-0 cursor-pointer fw-bold"
                  style={{ color: `#D18237` }}
                  onClick={this.showFilter.bind(this)}
                >
                  <i class="bi bi-filter"></i>Filters
                </p>
              </div>
              <div className="d-flex">
                {showFilters ? (
                  <div className="d-flex flex-column me-2 w-50">
                    <div className="card p-3 mt-1">
                      <h6 className="fw-bold" style={{ color: "black" }}>
                        <i
                          className="bi bi-arrow-left cursor-pointer me-2"
                          onClick={this.hideFilter.bind(this)}
                        ></i>
                        Filters
                      </h6>

                      <div className="d-flex mt-3 d-flex flex-column gap-2">
                        {Object.keys(schema.filters || {}).map((field) => {
                          let { type, ...options } = schema.filters[field];
                          return (
                            <InputFactory
                              key={field}
                              className="ms-1"
                              type={type}
                              field={field}
                              where={{}}
                              onChange={this.onChangeFilter.bind(this, type)}
                              {...options}
                            />
                          );
                        })}
                        {/* <Search
                          schemas={this.getSchemas()}
                          className="mt-1"
                          onSubmit={this.searchSubmit.bind(this)}
                          fields={schema.fields}
                        /> */}
                      </div>
                    </div>
                    {showDetails && empDetails && (
                      <div>
                        <EmployeeDetails
                          userLogin={user}
                          empDetails={empDetails}
                          clickView={this.onClickView.bind(this)}
                          clickEdit={this.onClickEdit.bind(this)}
                          clickStatus={this.onClickUpdateStatus.bind(this)}
                          clickDone={this.dialogUploadQC.bind(this)}
                        />
                      </div>
                    )}
                  </div>
                ) : (
                  ""
                )}

                <div className=" w-100">
                  <Table
                    fields={schema.fields}
                    onClick={this.clickData.bind(this)}
                    objects={objects}
                    // selectable
                    // collapsable
                    excludeFields={Object.keys(schema.fields).reduce(
                      (acc, key) => {
                        const options = schema.fields[key];

                        if (excludeFields.includes(key)) {
                          acc.push(key);
                        }
                        if (options.read === false) {
                          acc.push(key);
                        }
                        switch (options._type || options.type) {
                          case "Relation":
                          case "Array":
                          case "Object":
                          case "File":
                            acc.push(key);
                            break;
                          default:
                        }
                        return acc;
                      },
                      excludeFields
                    )}
                    selected={selected}
                    onSelect={this.onSelect.bind(this)}
                    onSelectAll={this.onSelectAll.bind(this)}
                    progress={progress}
                    onClickItem={this.onClickItem.bind(this)}
                    onSort={this.onClickSort.bind(this)}
                    className="mt-1"
                  />
                </div>
              </div>
            </div>
          </InfiniteScroll>
        </div>
        {user.roles[0].id === "Admin" && (
          <div className="position-fixed bottom-0 end-0 m-4">
            <Button
              className="btn shadow-sm text-white"
              onClick={this.onClickAdd.bind(this)}
              style={{
                width: "50px",
                height: "50px",
                borderRadius: "25px",
                backgroundColor: "#e09552",
              }}
            >
              <i className="bi bi-plus-lg" />
            </Button>
          </div>
        )}
      </>
    );
  }
}

export default withRouter(LastPayListPage);
